import { ProcurementPermissionScope } from './_models'
import { ProcurementPermissionCode } from './permissions'

/** Resolve UI scope for library modals from MANAGE then VIEW permission (defaults to VESSEL). */
export function libraryUiScope(
  getScope: (code: ProcurementPermissionCode | string) => ProcurementPermissionScope | null,
  manageCode:
    | ProcurementPermissionCode
    | string
    | Array<ProcurementPermissionCode | string>,
  viewCode: ProcurementPermissionCode | string,
): ProcurementPermissionScope {
  const manageCodes = Array.isArray(manageCode) ? manageCode : [manageCode]
  const manageScope = manageCodes.map((code) => getScope(code)).find(Boolean) ?? null
  return (manageScope ?? getScope(viewCode) ?? 'VESSEL') as ProcurementPermissionScope
}

/**
 * Most permissive library scope from VIEW and MANAGE (ALL > COMPANY > VESSEL).
 * Used to decide whether tenant-wide shared rows may be created without a vessel.
 */
export function libraryEffectiveScope(
  getScope: (code: ProcurementPermissionCode | string) => ProcurementPermissionScope | null,
  manageCode:
    | ProcurementPermissionCode
    | string
    | Array<ProcurementPermissionCode | string>,
  viewCode: ProcurementPermissionCode | string,
): ProcurementPermissionScope {
  const manageCodes = Array.isArray(manageCode) ? manageCode : [manageCode]
  const manage = manageCodes.map((code) => getScope(code)).find(Boolean) ?? null
  const view = getScope(viewCode)
  if (manage === 'ALL' || view === 'ALL') return 'ALL'
  if (manage === 'COMPANY' || view === 'COMPANY') return 'COMPANY'
  if (manage === 'VESSEL' || view === 'VESSEL') return 'VESSEL'
  return 'VESSEL'
}

/** True only for vessel-scoped library actors (crew); company/CGA/all may omit vessel. */
export function libraryVesselScopeLocked(
  getScope: (code: ProcurementPermissionCode | string) => ProcurementPermissionScope | null,
  manageCode:
    | ProcurementPermissionCode
    | string
    | Array<ProcurementPermissionCode | string>,
  viewCode: ProcurementPermissionCode | string,
): boolean {
  return libraryEffectiveScope(getScope, manageCode, viewCode) === 'VESSEL'
}
